import { render } from "./AddAlbumPage.vue?vue&type=template&id=1ad04c29&scoped=true"
import script from "./AddAlbumPage.vue?vue&type=script&lang=js"
export * from "./AddAlbumPage.vue?vue&type=script&lang=js"

import "./AddAlbumPage.vue?vue&type=style&index=0&id=1ad04c29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad04c29"]])

export default __exports__